import { Loader } from '@systemeio/ui'
import { CheckCircleIcon, OpenInNewIcon } from '@systemeio/ui/icons'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface TemplateCardProps {
  onSelect: () => void | Promise<void>
  isActive: boolean
  preview?: {
    href: string
    alt?: string
    dataTestId?: string
  }
  isFetching?: boolean
  className?: string
  dataTestId?: string
  style?: React.CSSProperties
}

export function TemplateCard({
  onSelect,
  preview,
  isActive,
  isFetching,
  className,
  children,
  style,
  dataTestId,
}: React.PropsWithChildren<TemplateCardProps>) {
  return (
    <div
      onClick={!isFetching ? onSelect : undefined}
      style={style}
      role="button"
      className={twMerge(
        'relative flex h-64 w-56 flex-col items-center justify-start overflow-hidden rounded-lg shadow-lg',
        'after:pointer-events-none after:absolute after:inset-0 after:z-20 after:rounded-lg after:border-2 after:border-transparent after:transition-colors after:duration-200 after:ease-linear',
        isActive && 'after:border-green',
        !isFetching && 'cursor-pointer',
        className,
      )}
    >
      <div className="border-fill-primary bg-background-secondary absolute top-0 right-0 z-10 flex items-center gap-1.5 rounded-bl-lg p-1.5 shadow-lg ">
        {preview && (
          <a
            onClick={e => e.stopPropagation()}
            className="ring-brand-primary group outline-none focus-visible:ring-2"
            href={preview.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={preview.alt}
            data-test-id={preview.dataTestId}
          >
            <OpenInNewIcon className="group-hover:fill-brand-primary main-transition-colors h-5 w-5" />
          </a>
        )}
        <button
          className="ring-brand-primary group rounded-full outline-none focus-visible:ring-2"
          type="button"
          onClick={e => {
            e.stopPropagation()
            onSelect()
          }}
          disabled={isFetching}
          data-test-id={dataTestId}
        >
          {isActive && isFetching ? (
            <Loader small className="h-5 w-5" />
          ) : (
            <CheckCircleIcon
              className={twMerge(
                'group-hover:fill-green main-transition-colors h-5 w-5',
                isActive && 'fill-green',
              )}
            />
          )}
        </button>
      </div>
      {children}
    </div>
  )
}
